import React from 'react';

import Spinner from '@components/common/Spinner/Spinner';

import css from './EditConfirmIcon.module.scss';

type EditConfirmIconProps = {
    onClose: () => void;
    onConfirm: () => void;
    isLoading?: boolean;
    customContainer?: string;
    customIcon?: string;
    customSpinner?: string;
    isDisabled?: boolean;
};

const EditIcon = ({
    onClose,
    onConfirm,
    isLoading,
    customContainer,
    customIcon,
    customSpinner,
    isDisabled,
}: EditConfirmIconProps) => {
    const handleConfirm = () => {
        !isDisabled && onConfirm();
    };
    return (
        <div className={customContainer ? `${customContainer} ${css.container}` : css.container}>
            {!isLoading ? (
                <>
                    <div onClick={onClose} className={`${css.icon} ${css.icon__close} ${customIcon && customIcon}`}>
                        <img src="/front-static/icons/navigation/close-white.svg" alt="close" />
                    </div>

                    <div
                        onClick={handleConfirm}
                        className={`${css.icon} ${css.icon__confirm} ${isDisabled ? css.icon__disabled : ''} ${customIcon && customIcon}`}
                    >
                        <img src="/front-static/icons/display/checkmark.svg" alt="check" />
                    </div>
                </>
            ) : (
                <Spinner customClass={`${css.container__spinner} ${customSpinner && customSpinner}`} />
            )}
        </div>
    );
};
export default EditIcon;
